var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductCellFormList',_vm._g({attrs:{"type":"projects","headers":_vm.searchItems,"disabled-edit-mode":_vm.disabledEditMode,"item":_vm.item,"view":''},on:{"saveFileProcess":_vm.saveFileProcess}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }